import Enum from './Enum.js';

export default class BonusTermType extends Enum {
  static SALARY_ALLOCATION = new BonusTermType('SALARY_ALLOCATION', '現状給与案分方式');
  static POINT_CONVERSION = new BonusTermType('POINT_CONVERSION', 'ポイント換算方式');
}
